import(/* webpackMode: "eager", webpackExports: ["Loader"] */ "/root/instacks_ui/src/components/ui/loader.tsx");
